<div class="search-companies-jobs">
  <p class="search-companies-jobs__total" i18n>{{ total$ | async }} offres</p>

  <job-lightweight
    *ngFor="let job of jobs$ | async; trackBy: trackById"
    [model]="job"
    [queryParams]="queryParams$ | async"
    [application]="(applications$ | async)?.get(job.id)"
    [bookmark]="(bookmarkMap$ | async)?.get(job.id)"
    (toggleBookmark)="toggleBookmark(job)"
    [trackingData]="{ eventCategory: 'Company Page', eventAction: 'Click See Job', eventLabel: 'Tab' }"
  ></job-lightweight>

  <ng-container *ngIf="loading$ | async">
    <job-lightweight-skeleton *ngFor="let tmp of [0, 1, 2, 3]; trackBy: trackByIndex"></job-lightweight-skeleton>
  </ng-container>

  <article class="jobs-fallback" *ngIf="(total$ | async) === 0">
    <h2 class="jobs-fallback__title" i18n>Oops, aucun résultat pour votre recherche&nbsp;!</h2>
    <p class="jobs-fallback__paragraph" i18n>
      WIZBII regroupe de nombreuses offres d'emploi, mais aucune ne correspond à vos critères.
    </p>
    <p class="jobs-fallback__paragraph" i18n>Adaptez vos critères pour obtenir plus de résultats.</p>
  </article>

  <div *ngIf="(nbPages$ | async) >= 2" class="search-companies-jobs__cta">
    <button class="btn btn--ghost" (click)="loadMore()" [disabled]="(page$ | async) + 1 >= (nbPages$ | async)" i18n>
      Voir plus
    </button>
  </div>
</div>
